import api from '@/services/Api';
import { ActionContext, Module } from 'vuex';
import { ImpfsettingsState, RootState } from '@/store/types';
import ImpfSetting from '@/types/Impfsetting';

type Context = ActionContext<ImpfsettingsState, RootState>;

export const impfsettings: Module<ImpfsettingsState, RootState> = {
    namespaced: true,
    state: {
        loaders: {
            impfsettings: false,
        },
        impfsettings: [],
    },
    actions: {
        loadImpfsettings({ commit }: Context): void {
            commit('setLoadersImpfsettings', true);

            api.get('verwaltung/impfsettings/load')
                .then((response) => commit('setImpfsettings', response.data.body))
                .catch(console.error)
                .finally(() => commit('setLoadersImpfsettings', false));
        },
    },
    mutations: {
        setImpfsettings(state: ImpfsettingsState, payload: Partial<ImpfSetting>[]): void {
            state.impfsettings = payload.map((data) => new ImpfSetting(data));
        },
        setLoadersImpfsettings(state: ImpfsettingsState, loading: boolean): void {
            state.loaders.impfsettings = loading;
        },
    },
    getters: {
        getImpfsettings: (state: ImpfsettingsState): ImpfSetting[] => {
            return state.impfsettings.map((setting) => ({
                ...setting,
                displayname: `${setting.setting_code} ${setting.displayname}`,
            }));
        },
    },
};
